import type { TFunction } from "i18next";
import U2000DeleteRecordDialog from "../../../../../u2000Core/components/dialog/U2000DeleteRecordDialog";
import type { U3143CadastreHandler } from "./U3143CadastreHandlers";

// Typage des props du composant
interface U3143CadastreDeleteDlgProps {
  u3143CadastreHandler: U3143CadastreHandler;
  t: TFunction;
  NS: string;
}

function U3143CadastreDeleteDlg({ u3143CadastreHandler, t, NS }: U3143CadastreDeleteDlgProps) {
  if (!u3143CadastreHandler.isDeleteDialogOpen) return null;

  return (
    <U2000DeleteRecordDialog isOpen={u3143CadastreHandler.isDeleteDialogOpen} onClose={u3143CadastreHandler.onDlgDeleteClose} title={t("lblCadastre", { ns: NS })}>
      <p className="mb-4">
        {t("msgDeleteCadastresConfirmation", {
          count: u3143CadastreHandler.gridStateHandlers.getSelectedRows().length,
          ns: NS,
        })}
      </p>
      <div className="mt-2 flex flex-wrap justify-center gap-x-2">
        {u3143CadastreHandler.gridStateHandlers.getSelectedRows().map((row, index, array) => (
          <span key={row.cadastreCode} className="inline-block text-gray-800">
            {`${row.cadastreCode}`}
            {index < array.length - 1 && ", "}
          </span>
        ))}
      </div>
    </U2000DeleteRecordDialog>
  );
}

export default U3143CadastreDeleteDlg;
